import { render, staticRenderFns } from "./OrderPackage.vue?vue&type=template&id=67cb8bc9&scoped=true"
import script from "./OrderPackage.vue?vue&type=script&lang=js"
export * from "./OrderPackage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67cb8bc9",
  null
  
)

export default component.exports